module.exports = __webpack_public_path__ + "img/img_level_1.56616c0b.png";